import { render, staticRenderFns } from "./CompanyDetailsGeneral.vue?vue&type=template&id=61a349b9&"
import script from "./CompanyDetailsGeneral.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports